<template>
  <div class="purchase-info" v-if="purchaseInfo">
    <div>
      <span style="font-size: 16px; font-weight: bolder; line-height: 35px">
        编号:{{ purchaseInfo.guid }}
      </span>
    </div>
    <div>
      <span> 当前状态: </span>
      <span
        class="purchase-status"
        :style="{
          backgroundColor: getStatusColor(),
          color: '#ffffff',
        }"
        v-if="getStatusLabel()"
      >
        {{ getStatusLabel() }}
      </span>
    </div>
    <div v-if="purchaseInfo.storeInfo">
      <span>采购门店: {{ purchaseInfo.storeInfo.name }}</span>
    </div>
    <div v-if="purchaseInfo.paymentAccount">
      <span>付款方式: {{ purchaseInfo.paymentAccount }}</span>
    </div>
    <div v-if="purchaseInfo.settlementState">
      <span>结算状态: {{ purchaseInfo.settlementState }}</span>
    </div>
    <div class="purchase-flex">
      <span class="desc-item" v-if="purchaseInfo.purchaseOrderRemark">
        <span>
          采购备注:
          <span>
            {{ purchaseInfo.purchaseOrderRemark }}
          </span>
        </span>
      </span>
      <span class="desc-item" v-if="purchaseInfo.createTime > 0">
        <span>
          创建时间:
          {{ new Date(purchaseInfo.createTime).format("YYYY-MM-dd hh:mm:ss") }}
        </span>
      </span>
      <span class="desc-item" v-if="purchaseInfo.arrangedGuid">
        <span>计划单号: {{ purchaseInfo.arrangedGuid }}</span>
      </span>
      <span class="desc-item" v-if="purchaseInfo.supplierInfo">
        <span>供货单位: {{ purchaseInfo.supplierInfo.name }}</span>
      </span>
      <span class="desc-item" v-if="purchaseInfo.purchaseGoodsCount > 0">
        采购数量:
        <span>
          {{ purchaseInfo.purchaseGoodsCount }}
        </span>
        <span> 份商品 </span>
      </span>
      <span class="desc-item" v-if="purchaseInfo.purchaseAmount > 0">
        采购金额:
        <span>
          {{ purchaseInfo.purchaseAmount }}
        </span>
        <span>元</span>
      </span>
      <span class="desc-item" v-if="purchaseInfo.freightAmount > 0">
        运费金额:
        <span>
          {{ purchaseInfo.freightAmount }}
        </span>
        <span>元</span>
      </span>
      <span class="desc-item" v-if="purchaseInfo.paymentAmount > 0">
        实付金额:
        <span>
          {{ purchaseInfo.paymentAmount }}
        </span>
        <span>元</span>
      </span>
      <span class="desc-item" v-if="purchaseInfo.handledBy">
        经手人员:
        <span>{{ purchaseInfo.handledBy }}</span>
      </span>
    </div>
    <div v-if="purchaseInfo.purchaseTrackingNumber">
      <div class="wordwrap">
        快递单号:
        <span>
          {{ purchaseInfo.purchaseTrackingNumber }}
        </span>
      </div>
    </div>
    <div v-if="purchaseInfo.optRemark">
      <div class="wordwrap">
        备注信息:
        <span class="purchase-remark">{{ purchaseInfo.optRemark }}</span>
      </div>
    </div>
    <div v-if="purchaseInfo.purchaseGoodsSnapshot">
      <div class="wordwrap">
        <span class="purchase-goods"> {{ purchaseInfo.purchaseGoodsSnapshot }} </span>
        <span v-if="purchaseInfo.purchaseRow > 5">
          （共{{ purchaseInfo.purchaseRow }}个商品，最多显示前5个商品）
        </span>
        <span v-else> （共{{ purchaseInfo.purchaseRow }}个商品） </span>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.purchase-remark {
  font-weight: bolder;
  line-height: 30px;
  color: #000000;
}

.purchase-goods {
  line-height: 30px;
  color: #333;
}

.purchase-flex {
  .desc-item {
    margin-right: 20px;
  }
}

.purchase-item-list {
  background: #fafafa;
  margin-top: 10px;
  padding: 10px;

  .item-info {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-top: 20px;
    margin-bottom: 20px;
    font-size: 14px;
  }

  .item-count {
    font-size: 14px;
  }
}

.purchase-status {
  width: auto;
  padding: 2px 5px;
  background-color: #ffffff;
  font-weight: 400;
  margin-right: 5px;
  border-radius: 5px;
  font-size: 14px;
  color: #5c5c5c;
}
</style>

<script>
export default {
  props: {
    showCount: {
      type: Boolean,
      default: false,
    },
    purchaseInfo: {
      type: Object,
    },
  },
  methods: {
    getStatusColor() {
      if (this.purchaseInfo.optStatus == 0) {
        return "#E6A23C";
      } else if (this.purchaseInfo.optStatus == 1) {
        return "#6F88A1";
      } else if (this.purchaseInfo.optStatus == 2) {
        return "#67C23A";
      } else if (this.purchaseInfo.optStatus == 3) {
        return "#F56C6C";
      }
      return "#919191";
    },
    getStatusLabel() {
      if (this.purchaseInfo.optStatus == 0) {
        return "等待入库";
      } else if (this.purchaseInfo.optStatus == 1) {
        return "部分入库";
      } else if (this.purchaseInfo.optStatus == 2) {
        return "已完成的";
      } else if (this.purchaseInfo.optStatus == 3) {
        return "已关闭的";
      }
      return "";
    },
  },
};
</script>
